import { AiScribeProvider } from '../context/useAiScribe';
import Collapsed from './collapsed/collapsed';
import Expanded from './expanded/expanded';

const AiScribeModal = () => {
  return (
    <AiScribeProvider>
      <Expanded />
      <Collapsed />
    </AiScribeProvider>
  );
};

export default AiScribeModal;
